import { CONFIG } from "@/config";

function setMetaDescription(content: string) {
  let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "description";
    document.head.appendChild(meta);
  }
  meta.content = content;
}

function setFavicon(href: string) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = href;
}

/**
 * Bridges the per-brand `CONFIG` (swapped in at CI build time from
 * whitelabel/<brand>/config.ts) into runtime CSS custom properties and
 * document metadata, since one built bundle must serve whichever brand's
 * config was baked in. Must run once, before the app renders.
 */
export function applyBrandTheme() {
  document.documentElement.style.setProperty("--brand-primary", CONFIG.primaryColour);
  document.documentElement.style.setProperty("--brand-secondary", CONFIG.secondaryColour);

  document.title = CONFIG.site_title;
  setMetaDescription(CONFIG.site_title);
  setFavicon(CONFIG.logo);
}
